<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveLanguages">
          <card>
            <template slot="header">
              <h3 class="card-title">Languages</h3>
            </template>
            <table width="100%">
              <thead>
              <th>Language</th>
              <th>Flag</th>
              <th>Locale Key</th>
              </thead>
              <tbody>
              <tr v-for="(language, index) in languages">
                <td>
                  <div class="lang-input">
                    <base-input
                      type="text"
                      :name="'language_name'+index"
                      v-validate="'required'"
                      :error="getError('language_name'+index)"
                      label="Language name"
                      placeholder="Language name"
                      v-model="language.languageName"
                    >
                    </base-input>
                  </div>
                </td>
                <td>
                  <div class="lang-input">
                    <base-input
                      type="text"
                      name="language"
                      :name="'language'+index"
                      v-validate="'required'"
                      :error="getError('language'+index)"
                      label="Locale key"
                      placeholder="Locale key"
                      v-model="language.language"
                    >
                    </base-input>
                  </div>
                </td>
                <td>
                  <div class="lang-input">
                    <div class="row">
                      <div class="col-lg-7">
                        <base-input
                          type="text"
                          :name="'flag'+index"
                          v-validate="'required'"
                          :error="getError('flag'+index)"
                          label="Flag symbol"
                          placeholder="Flag symbol"
                          v-model="language.flag"
                        >
                        </base-input>
                      </div>
                      <div class="col-lg-5">
                        <div class="mt-4 mb-auto">
                          <flag :iso="language.flag" v-bind:squared=false></flag>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <base-button @click="deleteLanguage(language)" type="danger" size="sm" class="btn-fill">
                    Delete
                  </base-button>
                </td>
              </tr>
              </tbody>
            </table>

            <template slot="footer">
              <base-button type="primary" native-type="submit" size="lg" class="btn-fill">
                Save
              </base-button>
              <base-button @click="addNewLanguage()" type="info" size="lg" class="btn-fill pull-right">
                Add new language
              </base-button>
            </template>
          </card>
        </form>
      </div>

    </div>
  </div>
</template>
<script>
  import {TabPane, Tabs} from 'src/components';
  import {LocalizationService} from '@/services';

  export default {
    components: {
      TabPane,
      Tabs
    },
    data() {
      return {
        languages: {},
        model: {
          translations: ''
        }
      }
    },
    methods: {
      async saveLanguages() {
        let isValidForm = await this.$validator.validateAll();
        if (isValidForm) {
          let loader = this.$loading.show();
          await LocalizationService.updateLanguages({languages: this.languages});
          await LocalizationService.init();
          this.$store.dispatch('Localization/setLanguages', LocalizationService.languages);
          loader.hide();
        }
      },
      addNewLanguage() {
        this.languages.push({
          languageName: '',
          language: '',
          flag: '',
        })
      },
      deleteLanguage(language) {
        if (confirm('Are you sure?')) {
          this.languages.splice(this.languages.indexOf(language), 1);
        }
      },
      getError: function (fieldName) {
        return this.errors.first(fieldName);
      }
    },
    async beforeCreate() {
      let loader = this.$loading.show();
      await LocalizationService.getLanguages().then((response) => {
        this.languages = response.data;
      }).catch((error) => {

      })

      loader.hide();
    }
  };
</script>
<style lang="scss" scoped>
  .lang-input {
    width: 80%;
  }

  .flag-icon {
    font-size: 1.5rem;
  }
</style>
